const OLIGODNA_PAGE = '/';
const EDIT_SEQUENCE_PAGE = '/edit-sequence/:plateName/';
const EDIT_PLATE_PAGE = '/edit-plate/:plateName/';

export default {
  OLIGODNA_PAGE,
  EDIT_SEQUENCE_PAGE,
  EDIT_PLATE_PAGE,
  PATHS: [
    OLIGODNA_PAGE,
    EDIT_PLATE_PAGE,
    EDIT_SEQUENCE_PAGE,
  ]
};
